import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import { CostPreloader } from 'components/Cost'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { Col } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

import {
  CostStyled,
  IndentBlock,
  Vat,
  VatWrapper,
  RowStyled,
  ColStyled,
} from './styles'

/**
 * CartSumBlock
 *
 * @param {object} props - properties of component
 * @returns {node} CartSumBlock
 */
const CartSumBlock = ({ cart, textsTotal, isLoading }) => {
  const { sales, currentCountry } = useContext(LocalizationContext)
  const { mobile } = useContext(ResizeContext)

  const VatBlock = React.useMemo(
    () => (
      <VatWrapper>
        <Vat dangerouslySetInnerHTML={{ __html: textsTotal.vat }} />
      </VatWrapper>
    ),
    [textsTotal.vat],
  )

  return (
    <RowStyled>
      <Col as={IndentBlock} width={{ xs: 1 / 2 }}>
        <TextLH dangerouslySetInnerHTML={{ __html: textsTotal.title }} />
        {mobile && VatBlock}
      </Col>
      <ColStyled width={{ xs: 1 / 2, md: 1 }}>
        {sales.goods && !isLoading ? (
          <>
            {cart.sum.realCost !== cart.sum.cost && (
              <>
                <CostStyled
                  size="cart"
                  value={cart.sum.realCost}
                  strikethrough={true}
                  intlCode={currentCountry.intlCode}
                  currency={sales.currency}
                />
                <br />
              </>
            )}
            <CostStyled
              size={cart.sum.realCost !== cart.sum.cost ? 'cartBig' : 'cart'}
              value={cart.sum.cost}
              intlCode={currentCountry.intlCode}
              currency={sales.currency}
            />
          </>
        ) : (
          <CostPreloader size="cart" />
        )}
        {!mobile && VatBlock}
      </ColStyled>
    </RowStyled>
  )
}

CartSumBlock.propTypes = {
  cart: PropTypes.object.isRequired,
  textsTotal: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
}

export default CartSumBlock
